<ng-template #viewVersionTmpl let-row="row" let-value="value">
  <a *ngIf="isGlobalAdmin" [routerLink]="['/admin/workflow-builder', row['workflowId'], row['workflowVersionId']]" target="_blank">
    View Version
  </a>
</ng-template>

<app-loader *ngIf="!publishRows"></app-loader>
<wm-datatable [loading]="publishLoading" [columns]="publishColumns"
  [availableColumns]="publishColumns" [rows]="publishRows" [count]="publishTotal" [offset]="publishPage"
  [limit]="publishPageSize" (settingsChanged)="publishSettingsChanged($event)" *ngIf="publishColumns && publishRows">

</wm-datatable>
